import type { ContainerType } from "~/container";
import type { IApi } from "~/interfaces/IApi";
import type { IAccountService } from "@saif-reporting/domain/interfaces/services/IAccountService.js";
import type { ChangeAccountPasswordRequest, UpdateAccountSettingsRequest, UpdateContactDetailsRequest } from "@saif-reporting/domain/dtos/accountDtos.js";
import type { AccountDto } from "@saif-reporting/domain/dtos/models/AccountDto.js";
import type { ContactDto } from "@saif-reporting/domain/dtos/models/ContactDto.js";
import type { MediaDto } from "@saif-reporting/domain/dtos/models/MediaDto.js";

export class AccountService implements IAccountService {
  private readonly api: IApi;
  constructor({ baseApi }: ContainerType) {
    this.api = baseApi;
  }

  async getUserAccount(): Promise<AccountDto> {
    return await this.api.$fetch<AccountDto>("/account", {
      method: "get",
    });
  }

  async getUserContactDetails(): Promise<ContactDto> {
    return await this.api.$fetch<ContactDto>("/account/contact-details", {
      method: "get",
    });
  }

  async getUserAvatar(): Promise<{ avatar: MediaDto | null }> {
    return await this.api.$fetch<{ avatar: MediaDto | null }>("/account/avatar", {
      method: "get",
    });
  }

  async changeAvatar(file: File): Promise<AccountDto> {
    const formData = new FormData();
    formData.append("file", file);
    const res = await this.api.$fetch<AccountDto>("/account/change-avatar", {
      method: "post",
      body: formData,
    });

    return res;
  }

  async updateSettings(dto: UpdateAccountSettingsRequest): Promise<void> {
    await this.api.$fetch("/account/update-settings", {
      method: "post",
      body: dto,
    });
  }

  async changePassword(dto: ChangeAccountPasswordRequest): Promise<void> {
    await this.api.$fetch("/account/change-password", {
      method: "post",
      body: dto,
    });
  }

  async updateContactDetails(dto: UpdateContactDetailsRequest): Promise<void> {
    await this.api.$fetch("/account/update-contact", {
      method: "post",
      body: dto,
    });
  }
}
